import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: auto;
  padding-bottom: 2rem;
  color: #9a9a9a;

  @media all and (max-width: 768px) {
    width: 100%;
    padding: 0 20px;
    margin: 0 0 50px 0;
  }
`;

export const Image = styled.img`
  width: 5rem;
  filter: brightness(0) saturate(100%) invert(75%) sepia(0%) saturate(521%) hue-rotate(144deg) brightness(83%)
    contrast(84%);
`;
export const Message = styled.p`
  text-align: center;
  margin-top: 1rem;
  font-size: 1.2rem;
`;
export const Phone = styled.p`
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 1rem;
`;
export const Email = styled.p`
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 1rem;
`;

export const LinkList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-top: 1.5rem;
`;

export const LinkItem = styled.a`
  font-size: 1.2rem;
  color: #020c90;
  text-decoration: none;
  font-weight: 500;
  padding: 5px 15px;
  border: 1px solid #020c90;
  border-radius: 20px;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #020c90;
    color: #fff;
  }
`;

export const DescriptionText = styled.p`
  font-size: 1.2rem;
  color: #9a9a9a;
  text-align: center;
  max-width: 600px;
  margin-top: 1.2rem;
  line-height: 1.6;
  white-space: pre-wrap;
`;

export const HoursText = styled.p`
  font-size: 1.1rem;
  color: #9a9a9a;
  text-align: center;
  margin-top: 0.8rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
`;
